export default __webpack_public_path__ + "static/running-bd177e48d76a06466890ea66f22c780b.webp";